import React, { useEffect, useState } from "react";
import { localStorageHelper } from "../../system/helper/localStorage";
import { useSelector } from "react-redux";
import { RootState } from "../../redux/reducers";
import { UserSessionApi } from "../../system/api/UserSessionApi";
import { dispatch } from "../../App";
import { actions } from "../../redux";
import { activeUser } from "../../system/types/activeUser/activeUserType";
import { SystemApi } from "../../system/api/SystemApi";

const ActiveUser = () => {

    const [activeSession, setActiveSession] = useState<string>('');
    const [activeUserEmail, setActiveUserEmail] = useState<string>('');
    const [activeUserData, setActiveUserData] = useState<activeUser>();
    const [userSessionActive, setUserSessionActive] = useState<boolean>(false);

    useSelector((state: RootState) => {
        if (state.activeUser.activeUserToken !== activeSession) {
            setActiveSession(state.activeUser.activeUserToken);
        }
        if (state.activeUser.activeUserEmail !== activeUserEmail) {
            setActiveUserEmail(state.activeUser.activeUserEmail);
        }
        if (state.activeUser.activeUserData !== activeUserData) {
            setActiveUserData(state.activeUser.activeUserData);
        }
        if (state.activeUser.activeUserIsValid !== userSessionActive) {
            setUserSessionActive(state.activeUser.activeUserIsValid);
        }
    });

    const loadAvailableLanguages = async () => {
        const api = new SystemApi(activeSession, activeUserEmail);
        const results = await api.getLanguageList();
        
        dispatch(actions.system.setLanguages(results.languages));
    };

    const checkSessionValidity = async () => {
        const api = new UserSessionApi();
        const result = await api.requestSessionValidation(activeSession, activeUserEmail);

        const storage = new localStorageHelper();

        if (typeof result === 'undefined' || !result.success) {
            dispatch(actions.system.setLanguages([]));
            dispatch(actions.activeUser.clearData());
            storage.deleteItem('activeUserSession');
            storage.deleteItem('activeUserEmail');
            return;
        }

        dispatch(actions.activeUser.setValidity(true));
        dispatch(actions.activeUser.setEmail(activeUserEmail));
        dispatch(actions.activeUser.setData(result.userData));

        loadAvailableLanguages();

        storage.setItem('activeUserSession', activeSession);
        storage.setItem('activeUserEmail', activeUserEmail);
    }

    useEffect(() => {

        if (activeUserEmail !== '' || activeSession !== '') {
            checkSessionValidity();
            return;
        }

        const storage = new localStorageHelper();
        const storedSession = storage.getItem<string>('activeUserSession');
        const storedEmail = storage.getItem<string>('activeUserEmail');

        if (storedEmail !== null && storedEmail !== '') {
            dispatch(actions.activeUser.setEmail(storedEmail));
        }

        if (storedSession !== null && storedSession !== '') {
            dispatch(actions.activeUser.setToken(storedSession));
        }

    }, [activeSession, activeUserEmail]);

    return (<></>)
};

export { ActiveUser };
